// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "sidebar-1zcef";
var _3 = "root-1PLEO";
var _4 = "title-1Lec2";
export { _1 as "__esModule", _2 as "sidebar", _3 as "root", _4 as "title" }
export default { "__esModule": _1, "sidebar": _2, "root": _3, "title": _4 }
